import { useDictionaryContext } from '3-foundation/Dictionary/DictionaryContext';

export const useSearchDictionary = () => {
	const dictionary = useDictionaryContext();

	return {
		showAll: dictionary.getSearch('ShowAll'),
		foundAt: dictionary.getSearch('FoundAt'),
		tagsOther: dictionary.getSearch('TagsOther'),
		typeNewsPage: dictionary.getSearch('TypeNewsPage'),
		typeNewsCatalogPage: dictionary.getSearch('TypeNewsCatalogPage'),
		typeEventPage: dictionary.getSearch('TypeEventPage'),
		typeEventCatalogPage: dictionary.getSearch('TypeEventCatalogPage'),
		typeContentPage: dictionary.getSearch('TypeContentPage'),
		typeSubjectPage: dictionary.getSearch('TypeSubjectPage'),
		typeArticlePage: dictionary.getSearch('TypeArticlePage'),
		typeHomePage: dictionary.getSearch('TypeHomePage'),
		typeContactPersonPage: dictionary.getSearch('TypeContactPersonPage'),
		btnSearch: dictionary.getSearch('BtnSearch'),
		inputPlaceholder: dictionary.getSearch('InputPlaceholder'),
		yourSearchGave$NumberResults: dictionary.getSearch('YourSearchGave$NumberResults'),
	};
};
